import { ILogbookStateReportState } from './logbook-state-report.model';
import { Action } from '@ngrx/store';
import * as Actions from './logbook-state-report.actions';
import _ from 'lodash';

export const logbookStateReportInitialState: ILogbookStateReportState = {
  getLogbookStateReportDataLoading: false,
  getLogbookStateReportDataLoaded: false,
  logbookStateReportData: null,
  tableSettings: [],
  errors: [],
};

export function logbookStateReportReducer(
  state: ILogbookStateReportState = logbookStateReportInitialState,
  baseAction: Action,
): ILogbookStateReportState {
  const action = baseAction as Actions.LogbookStateReportActions;

  switch (action.type) {
    case Actions.GET_LOGBOOK_STATE_REPORT_DATA:
      return {
        ...state,
        getLogbookStateReportDataLoading: true,
        getLogbookStateReportDataLoaded: false,
      };
    case Actions.GET_LOGBOOK_STATE_REPORT_DATA_COMPLETED:
      return {
        ...state,
        logbookStateReportData: action.response,
        getLogbookStateReportDataLoading: false,
        getLogbookStateReportDataLoaded: true,
      };
    case Actions.SET_TABLE_SETTINGS:
      return {
        ...state,
        tableSettings: action.payload,
      };
    case Actions.FETCH_ERROR:
      const errors = _.cloneDeep(state.errors);
      errors.push(action.payload);
      return {
        ...state,
        errors,
        getLogbookStateReportDataLoading: false,
      };

    default:
      return state;
  }
}
